import React, { useState } from "react";
import "./MyTable.scss";
import TableButton from "../components/TableButton";
import TablePopup from "../components/TablePopup";

const statuses = [
  { label: "Not Ordered", color: "#D7D7D7" },
  { label: "Ordered", color: "#F2A91C" },
  { label: "Payment Initiated", color: "#067904" },
  { label: "Uncleaned", color: "#DC1818" },
];

const tableData = [
  {
    tableNumber: "01",
    tableTime: "",
    peopleCount: 4,
    status: "Not Ordered",
    showPeople: true,
    showArrow: false,
    color: "#D7D7D7",
  },
  {
    tableNumber: "02",
    tableTime: "",
    peopleCount: 4,
    status: "Payment Initiated",
    showPeople: true,
    showArrow: false,
    color: "#067904",
  },
  {
    tableNumber: "03",
    tableTime: "",
    peopleCount: 3,
    status: "Ordered",
    showPeople: true,
    showArrow: false,
    color: "#F2A91C",
  },
  {
    tableNumber: "04",
    tableTime: "",
    peopleCount: 4,
    status: "Uncleaned",
    showPeople: true,
    showArrow: false,
    color: "#DC1818",
  },
  {
    tableNumber: "05",
    tableTime: "",
    peopleCount: 4,
    status: "Not Ordered",
    showPeople: true,
    showArrow: false,
    color: "#D7D7D7",
  },
  {
    tableNumber: "06",
    tableTime: "",
    peopleCount: 4,
    status: "Payment Initiated",
    showPeople: true,
    showArrow: false,
    color: "#067904",
  },
  {
    tableNumber: "07",
    tableTime: "",
    peopleCount: 3,
    status: "Ordered",
    showPeople: true,
    showArrow: false,
    color: "#F2A91C",
  },
  {
    tableNumber: "08",
    tableTime: "",
    peopleCount: 4,
    status: "Uncleaned",
    showPeople: true,
    showArrow: false,
    color: "#DC1818",
  },
];

function MyTable() {
  const [popupData, setPopupData] = useState<{
    tableNumber: string;
    peopleCount: number;
  } | null>(null);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);

  const handleTableClick = (tableNumber: string, peopleCount: number) => {
    setPopupData({ tableNumber, peopleCount });
  };

  const toggleStatus = (status: string) => {
    setSelectedStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status]
    );
  };

  const filteredTables =
    selectedStatuses.length > 0
      ? tableData.filter((table) => selectedStatuses.includes(table.status))
      : tableData;

  return (
    <div className="mytable">
      <div className="checkbox_list">
        {statuses.map((item, index) => (
          <div className="checkbox_item" key={index}>
            <input
              type="checkbox"
              id={`status-${index}`}
              checked={selectedStatuses.includes(item.label)}
              onChange={() => toggleStatus(item.label)}
            />
            <label htmlFor={`status-${index}`}>{item.label}</label>
          </div>
        ))}
      </div>

      <div className="table_color_list">
        <div className="table">
          {filteredTables.map((table, index) => (
            <TableButton
              key={index}
              tableNumber={table.tableNumber}
              tableTime={table.tableTime}
              peopleCount={table.peopleCount}
              showPeople={table.showPeople}
              showArrow={table.showArrow}
              backgroundColor={table.color}
              color={table.color}
              onClick={() =>
                handleTableClick(table.tableNumber, table.peopleCount)
              } // <-- FIX
            />
          ))}
        </div>

        <div className="color_list">
          {statuses.map((item, index) => (
            <div className="color_status" key={index}>
              <span
                style={{ backgroundColor: item.color }}
                className="color_dot"
              ></span>
              <p>{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      {popupData && (
        <TablePopup
          tableNumber={popupData.tableNumber}
          peopleCount={popupData.peopleCount}
          onClose={() => setPopupData(null)}
        />
      )}
    </div>
  );
}

export default MyTable;
